import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { ToggleService } from "src/app/services/toggle.service";
import { ChatService } from "src/app/chat.service";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
declare var $: any;

@Component({
  selector: "app-chatbot-icon",
  templateUrl: "./chatbot-icon.component.html",
  styleUrls: ["./chatbot-icon.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatbotIconComponent implements OnInit {
  @Output() toggleChatBotEv = new EventEmitter<number>();
  @Output() clearMessages = new EventEmitter<any>();
  @Input() imgName: string;
  @Output() sendMsgEv = new EventEmitter();
  closeBtnShow: boolean = false;
  showHelpText: boolean = false;
  chatbotLang = 'en';
  constructor(
    private readonly toggleService: ToggleService,
    private readonly chatService: ChatService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.toggleService.watchIconStatus().subscribe((data) => {
      this.closeBtnShow = data;
      if (!this.closeBtnShow) {
        // this.showHelpText = true;
        // setTimeout(() => {
        //   this.showHelpText = false;
        // }, 5000);
      } else {
        this.showHelpText = false;
      }
    });
  }

  ngOnInit() {
    this.router.events
        .subscribe((event) => {
          if (event instanceof NavigationEnd) {
            // Get a good value
            const params = this.route.snapshot.queryParams;
            if (params.lang) {
              this.chatbotLang = params.lang;
            }
          }
        });
  }
  toggleChatBot(num: number) {
    if (num === 2) {
      this.clearMessages.emit();
      num = 0;
    }
    this.toggleService.toggleChatbot(num);
    if (!this.chatService.iconToggled) {
      this.chatService.iconToggled = true;
      this.chatService.wsConnected.subscribe((data) => {
        if (data) {
          if (!sessionStorage?.agentSession && this.chatService.isNeedSendHello) {
            this.chatService.isNeedSendHello = false;
            this.sendMsgEv.emit({msg: (!this.chatbotLang || this.chatbotLang == 'en') ? "Hello" : "مرحبا"});
          }
          this.chatService.wsConnected.unsubscribe();
        }
      });
    }
  }
}
